import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import classnames from 'classnames';
import { AtlSelectProps, AtlSelectOption } from './props';
import { getGlobalStyleSheets } from '../../../global-styles';
import {
   Sizes,
   enumAttributeConverter,
   SizesValuesMap,
} from '../../enum-types';

import * as TagNames from './select.tagnames';
import { AtlSelectChangeEvent } from './select.events';

@customElement(TagNames.Select)
export class AtlSelect extends LitElement implements AtlSelectProps {
   declare internalId: string;
   declare name: string;
   declare size?: Sizes;
   declare selectClassName?: string;
   declare selectValue: AtlSelectOption;
   declare options: Array<AtlSelectOption>;
   declare selectInactive?: boolean;
   declare disallowDeselect?: boolean;

   static properties = {
      internalId: { type: String },
      selectClassName: { type: String },
      name: { type: String },
      size: {
         type: String,
         convertor: enumAttributeConverter(Sizes, Sizes.Medium),
      },
      selectValue: { type: Object },
      options: { type: Array<AtlSelectOption[]>() },
      selectInactive: { type: Boolean },
      disallowDeselect: { type: Boolean },
   };

   constructor() {
      super();
      this.internalId = '';
      this.selectClassName = '';
      this.name = '';
   }

   static styles = [...getGlobalStyleSheets()];

   renderDefaultOption() {
      if (this.selectValue && this.disallowDeselect) {
         return nothing;
      }
      return html`<option tabindex="0" part="atl-select-option" value="-1">Please Select...</option>`;
   }

   renderOption(value: string, label: string) {
      if (this.selectValue && this.selectValue.value === value) {
         return html`<option tabindex="0" part="atl-select-option" value=${value} selected>
            ${label}
         </option>`;
      }
      return html`<option tabindex="0" part="atl-select-option" value=${value}>${label}</option>`;
   }

   render() {
      return html`
         <select
            id=${this.internalId}
            class=${classnames(
               'form-control form-select',
               this.selectClassName,
               SizesValuesMap[this.size ?? Sizes.Medium]
            )}
            title=${this.name}
            value=${this.selectValue?.value}
            ?disabled=${this.selectInactive === true}
            @change=${this._handleOnChange}
            tabindex="0"
         >
            ${this.renderDefaultOption()}
            ${this.options.map((o) => this.renderOption(o.value, o.label))}
         </select>
      `;
   }

   protected _handleOnChange = (e: Event & { target: HTMLSelectElement }) => {
      this.dispatchEvent(new AtlSelectChangeEvent(e.target.value));
   };
}
